
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import AgentConnectBanner from "../assets/Agent-Connect-Banner.jpg";
import { getDatabase, ref, set, get } from "firebase/database";
import { 
  FaTimes, FaLock, FaArrowRight, FaBuilding, FaPhone, 
  FaEnvelope, FaIdCard, FaUser, FaMapMarkerAlt, FaGlobe 
} from "react-icons/fa";
import { getAuth, signInWithEmailAndPassword, createUserWithEmailAndPassword, sendPasswordResetEmail } from "firebase/auth";
import SEO from "./SEO";
const AgentConnect = () => {
  const [showSignup, setShowSignup] = useState(false);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [sentOtp, setSentOtp] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [resetEmail, setResetEmail] = useState("");
  const [enteredOtp, setEnteredOtp] = useState("");
  const [resetStep, setResetStep] = useState(1); // 1: email, 2: OTP, 3: confirmation
  
  const [formData, setFormData] = useState({
    companyName: "",
    mobile: "",
    email: "",
    password: "",
    confirmPassword: "",
    panNumber: "",
    panName: "",
    firstName: "",
    lastName: "",
    address: "",
    country: "",
    state: "",
    city: "",
    pinCode: "",
  });
  const [loginData, setLoginData] = useState({
    email: "",
    password: ""
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [otpSending, setOtpSending] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleLoginChange = (e) => {
    const { name, value } = e.target;
    setLoginData(prev => ({ ...prev, [name]: value }));
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    if (!loginData.email || !loginData.password) {
      setError("Please enter both email and password");
      setLoading(false);
      return;
    }

    const auth = getAuth();
    try {
      const userCredential = await signInWithEmailAndPassword(auth, loginData.email, loginData.password);
      const user = userCredential.user;

      // Fetch agent data from Realtime DB
      const db = getDatabase();
      const emailKey = user.email.replace(/\./g, '_');
      const agentRef = ref(db, `Agent/${emailKey}`);
      const snapshot = await get(agentRef);

      if (snapshot.exists()) {
        const agentData = snapshot.val();
        
        // Check if agent is active
        if (agentData.isActive === false) {
          setError("Your account is not active. Please contact support.");
          setLoading(false);
          return;
        }
        
        // Store in localStorage for quick access
        localStorage.setItem('isAuthenticated', 'true');
        localStorage.setItem("agent", JSON.stringify({
          ...agentData,
          uid: user.uid,
          email: user.email
        }));
      
        navigate("/Departure");
      } else {
        setError("Agent data not found. Please contact support.");
      }
    } catch (err) {
      console.error("Login error:", err);
      setError(getFirebaseErrorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  const handleSignup = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    // Validate passwords match
    if (formData.password !== formData.confirmPassword) {
      setError("Passwords do not match");
      setLoading(false);
      return;
    }

    const auth = getAuth();
    const db = getDatabase();
    
    try {
      // 1. Create auth user
      await createUserWithEmailAndPassword(auth, formData.email, formData.password);

      // 2. Prepare agent data
      const agentData = {
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.email,
        companyName: formData.companyName,
        mobile: formData.mobile,
        address: formData.address,
        country: formData.country,
        state: formData.state,
        city: formData.city,
        pinCode: formData.pinCode,
        panName: formData.panName,
        panNumber: formData.panNumber,
        isActive: false, // New agents are inactive by default
        createdAt: new Date().toISOString()
      };

      // 3. Store in Realtime DB
      const emailKey = formData.email.replace(/\./g, '_');
      const agentRef = ref(db, `Agent/${emailKey}`);
      await set(agentRef, agentData);

      // 4. Show success message and redirect to login
      setSuccessMessage("Registration successful! Your account is under review. We'll notify you once activated.");
      setShowSignup(false);
      setFormData({
        companyName: "",
        mobile: "",
        email: "",
        password: "",
        confirmPassword: "",
        panNumber: "",
        panName: "",
        firstName: "",
        lastName: "",
        address: "",
        country: "",
        state: "",
        city: "",
        pinCode: "",
      });
      
    } catch (err) {
      console.error("Signup error:", err);
      setError(getFirebaseErrorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  const handleForgotPassword = async () => {
    setError("");
    
    if (!resetEmail) {
      setError("Please enter your email address");
      return;
    }

    setOtpSending(true);

    // Check if email exists in Firebase
    const db = getDatabase();
    const emailKey = resetEmail.replace(/\./g, '_');
    const agentRef = ref(db, `Agent/${emailKey}`);
    
    try {
      const snapshot = await get(agentRef);
      if (!snapshot.exists()) {
        setError("No account found with this email address");
        setOtpSending(false);
        return;
      }

      const agentData = snapshot.val();
      setMobileNumber(agentData.mobile);
      
      // Generate and send OTP
      const otp = generateRandomCode();
      setSentOtp(otp);
      setResetStep(2);
  
      // Send OTP via SMS
      const message = `Your Verification Code is ${otp}. - Expertskill Technology.`;
      const accusage = "1";
      const encodedMessage = encodeURIComponent(message);

      const username = "Experts";
      const authkey = "ba9dcdcdfcXX";
      const mobiles = "+91" + agentData.mobile.trim();
      const senderId = "EXTSKL";

      const mainUrl = "https://mobicomm.dove-sms.com/submitsms.jsp?";
      const url = `${mainUrl}user=${username}&key=${authkey}&mobile=${mobiles}&message=${encodedMessage}&accusage=${accusage}&senderid=${senderId}`;
      
      // Send OTP via SMS API
      try {
        const response = await fetch(url);
        if (response.ok) {
          setSuccessMessage("OTP has been sent to your registered mobile number");
        } else {
          setError("Failed to send OTP. Please try again.");
        }
      } catch (err) {
        console.error("Error sending OTP:", err);
        // For demo purposes, we'll still proceed even if SMS fails
        setSuccessMessage("OTP has been generated. In production, this would be sent via SMS.");
      }
    } catch (err) {
      console.error("Error in forgot password:", err);
      setError("Failed to process your request. Please try again.");
    } finally {
      setOtpSending(false);
    }
  };

  const verifyOtp = () => {
    if (enteredOtp === sentOtp) {
      setResetStep(3);
      setError("");
      setSuccessMessage("OTP verified successfully. Sending password reset email...");
      sendPasswordReset();
    } else {
      setError("Invalid OTP. Please try again.");
    }
  };

  const sendPasswordReset = async () => {
    const auth = getAuth();
    
    try {
      // Use Firebase's sendPasswordResetEmail method
      await sendPasswordResetEmail(auth, resetEmail);
      
      setSuccessMessage("Password reset email sent! Check your inbox for instructions.");
      setTimeout(() => {
        setShowForgotPassword(false);
        setResetStep(1);
        setResetEmail("");
        setEnteredOtp("");
        setSuccessMessage("");
      }, 3000);
    } catch (err) {
      console.error("Error sending password reset email:", err);
      setError("Failed to send password reset email. Please try again.");
    }
  };

  const generateRandomCode = () => {
    return Math.floor(100000 + Math.random() * 900000).toString();
  };

  // Helper function to get user-friendly error messages
  const getFirebaseErrorMessage = (error) => {
    switch (error.code) {
      case "auth/email-already-in-use":
        return "Email already in use";
      case "auth/invalid-email":
        return "Invalid email address";
      case "auth/weak-password":
        return "Password should be at least 6 characters";
      case "auth/user-not-found":
        return "No account found with this email";
      case "auth/wrong-password":
        return "Incorrect password";
      default:
        return "An error occurred. Please try again.";
    }
  };

  return (
    <>
         <SEO
        title="Agent Connect | Pearl Tours & Travels"
        description="Join Pearl Tours & Travels as a travel agent and get exclusive access to packages and commissions."
        keywords="agent connect, travel agents India, Pearl Tours agent program, travel agent partnership"
      />
      <div className="agent-connect-wrapper">
        <main
          className="agent-connect-main"
          style={{ backgroundImage: `url(${AgentConnectBanner})` }}
        >
          <div className="left-image"></div>

          <div className="right-login-box">
            <div className="form-content">
              <h2>WELCOME TO Pearl INTERNATIONAL FOR B2B!</h2>
              <p className="subtitle">Please login to continue</p>
              
              {successMessage && (
                <div className="success-message">
                  {successMessage}
                </div>
              )}
              
              {error && <div className="error-message">{error}</div>}
              
              <form className="login-form" onSubmit={handleLogin}>
                <div className="input-group">
                  <FaEnvelope className="input-icon" />
                  <input 
                    type="email" 
                    name="email"
                    placeholder="Email" 
                    value={loginData.email}
                    onChange={handleLoginChange}
                    required 
                  />
                </div>
                <div className="input-group">
                  <FaLock className="input-icon" />
                  <input 
                    type="password" 
                    name="password"
                    placeholder="Password" 
                    value={loginData.password}
                    onChange={handleLoginChange}
                    required 
                  />
                </div>
                
                <button type="submit" className="login-btn" disabled={loading}>
                  {loading ? 'Logging in...' : 'Log in'}
                </button>
              </form>
              
              <div className="links">
                <a href="#" className="link" onClick={() => setShowForgotPassword(true)}>
                  <FaLock className="link-icon" /> Forgot your password? <strong>Reset Here</strong>
                </a>
                <a href="#" onClick={() => setShowSignup(true)} className="link signup-link">
                  Don't have an account? <strong>Sign up here</strong> <FaArrowRight className="arrow-icon" />
                </a>
              </div>
            </div>
          </div>
        </main>

        {/* Registration Modal */}
        {showSignup && (
          <div className="modal-overlay">
            <div className="modal-form">
              <div className="modal-header">
                <h2>Register Your Agency</h2>
                <button 
                  className="close-btn" 
                  onClick={() => {
                    setShowSignup(false);
                    setError("");
                  }}
                  disabled={loading}
                >
                  <FaTimes />
                </button>
              </div>
              {error && <div className="error-message">{error}</div>}
              <form onSubmit={handleSignup} className="registration-form">
                <div className="form-grid">
                  <div className="input-group">
                    <FaBuilding className="input-icon" />
                    <input 
                      name="companyName" 
                      placeholder="Company Name *" 
                      required 
                      onChange={handleChange}
                      value={formData.companyName}
                    />
                  </div>
                  <div className="input-group">
                    <FaPhone className="input-icon" />
                    <input 
                      name="mobile" 
                      placeholder="Mobile Number *" 
                      required 
                      onChange={handleChange}
                      value={formData.mobile}
                      type="tel"
                    />
                  </div>
                  <div className="input-group">
                    <FaEnvelope className="input-icon" />
                    <input 
                      name="email" 
                      placeholder="Email *" 
                      type="email" 
                      required 
                      onChange={handleChange}
                      value={formData.email}
                    />
                  </div>
                  <div className="input-group">
                    <FaLock className="input-icon" />
                    <input 
                      name="password" 
                      placeholder="Password *" 
                      type="password" 
                      required 
                      onChange={handleChange}
                      value={formData.password}
                      minLength="6"
                    />
                  </div>
                  <div className="input-group">
                    <FaLock className="input-icon" />
                    <input 
                      name="confirmPassword" 
                      placeholder="Confirm Password *" 
                      type="password" 
                      required 
                      onChange={handleChange}
                      value={formData.confirmPassword}
                      minLength="6"
                    />
                  </div>
                  <div className="input-group">
                    <FaIdCard className="input-icon" />
                    <input 
                      name="panNumber" 
                      placeholder="Pan Number" 
                      onChange={handleChange}
                      value={formData.panNumber}
                    />
                  </div>
                  <div className="input-group">
                    <FaIdCard className="input-icon" />
                    <input 
                      name="panName" 
                      placeholder="Pan Name" 
                      onChange={handleChange}
                      value={formData.panName}
                    />
                  </div>
                  <div className="input-group">
                    <FaUser className="input-icon" />
                    <input 
                      name="firstName" 
                      placeholder="First Name *" 
                      required
                      onChange={handleChange}
                      value={formData.firstName}
                    />
                  </div>
                  <div className="input-group">
                    <FaUser className="input-icon" />
                    <input 
                      name="lastName" 
                      placeholder="Last Name *" 
                      required
                      onChange={handleChange}
                      value={formData.lastName}
                    />
                  </div>
                  <div className="input-group">
                    <FaMapMarkerAlt className="input-icon" />
                    <input 
                      name="address" 
                      placeholder="Address *" 
                      required
                      onChange={handleChange}
                      value={formData.address}
                    />
                  </div>
                  <div className="input-group">
                    <FaGlobe className="input-icon" />
                    <input 
                      name="country" 
                      placeholder="Country *" 
                      required
                      onChange={handleChange}
                      value={formData.country}
                    />
                  </div>
                  <div className="input-group">
                    <FaMapMarkerAlt className="input-icon" />
                    <input 
                      name="state" 
                      placeholder="State *" 
                      required
                      onChange={handleChange}
                      value={formData.state}
                    />
                  </div>
                  <div className="input-group">
                    <FaMapMarkerAlt className="input-icon" />
                    <input 
                      name="city" 
                      placeholder="City *" 
                      required
                      onChange={handleChange}
                      value={formData.city}
                    />
                  </div>
                  <div className="input-group">
                    <FaMapMarkerAlt className="input-icon" />
                    <input 
                      name="pinCode" 
                      placeholder="Pin Code *" 
                      required
                      onChange={handleChange}
                      value={formData.pinCode}
                    />
                  </div>
                </div>
                <div className="form-actions">
                  <button 
                    type="submit" 
                    className="submit-btn"
                    disabled={loading}
                  >
                    {loading ? 'Registering...' : 'Register Now'}
                  </button>
                  <button 
                    type="button" 
                    onClick={() => {
                      setShowSignup(false);
                      setError("");
                    }} 
                    className="cancel-btn"
                    disabled={loading}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

        {/* Forgot Password Modal */}
        {showForgotPassword && (
          <div className="modal-overlay">
            <div className="modal-form">
              <div className="modal-header">
                <h2>Reset Password</h2>
                <button 
                  className="close-btn" 
                  onClick={() => {
                    setShowForgotPassword(false);
                    setError("");
                    setResetStep(1);
                    setResetEmail("");
                    setSuccessMessage("");
                  }}
                >
                  <FaTimes />
                </button>
              </div>
              
              {error && <div className="error-message">{error}</div>}
              {successMessage && <div className="success-message">{successMessage}</div>}
              
              {resetStep === 1 && (
                <div className="reset-form">
                  <p>Enter your registered email to receive an OTP on your mobile number</p>
                  <div className="input-group">
                    <FaEnvelope className="input-icon" />
                    <input 
                      type="email" 
                      placeholder="Enter your registered email" 
                      value={resetEmail}
                      onChange={(e) => setResetEmail(e.target.value)}
                      required 
                    />
                  </div>
                  <button 
                    className="submit-btn"
                    onClick={handleForgotPassword}
                    disabled={otpSending}
                  >
                    {otpSending ? 'Sending OTP...' : 'Send OTP'}
                  </button>
                </div>
              )}
              
              {resetStep === 2 && (
                <div className="reset-form">
                  <p>OTP sent to your registered mobile number ending with {mobileNumber.slice(-3)}</p>
                  <div className="input-group">
                    <FaLock className="input-icon" />
                    <input 
                      type="text" 
                      placeholder="Enter OTP" 
                      value={enteredOtp}
                      onChange={(e) => setEnteredOtp(e.target.value)}
                      required 
                      maxLength="6"
                    />
                  </div>
                  <button 
                    className="submit-btn"
                    onClick={verifyOtp}
                  >
                    Verify OTP
                  </button>
                  <button 
                    className="resend-btn"
                    onClick={handleForgotPassword}
                    disabled={otpSending}
                  >
                    {otpSending ? 'Resending...' : 'Resend OTP'}
                  </button>
                </div>
              )}
              
              {resetStep === 3 && (
                <div className="reset-form">
                  <p>Password reset email has been sent to {resetEmail}. Please check your inbox and follow the instructions to reset your password.</p>
                  <button 
                    className="submit-btn"
                    onClick={() => {
                      setShowForgotPassword(false);
                      setResetStep(1);
                      setResetEmail("");
                      setEnteredOtp("");
                      setSuccessMessage("");
                    }}
                  >
                    Close
                  </button>
                </div>
              )}
            </div>
          </div>
        )}
      </div>

      <style>{`
        * {
          box-sizing: border-box;
          margin: 0;
          padding: 0;
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        }

        .agent-connect-wrapper {
          height: 100vh;
          display: flex;
          flex-direction: column;
        }

        .agent-connect-main {
          display: flex;
          height: 100%;
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          position: relative;
        }

        .left-image {
          flex: 1;
        }

        .right-login-box {
          flex: 1;
          display: flex;
          justify-content: center;
          align-items: center;
          backdrop-filter: blur(5px);
        }

        .form-content {
          background: rgba(255, 255, 255, 0.95);
          padding: 40px;
          border-radius: 15px;
          max-width: 450px;
          width: 100%;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
          text-align: center;
        }

        .form-content h2 {
          color: #c1212a;
          margin-bottom: 10px;
          font-size: 24px;
        }

        .subtitle {
          color: #666;
          margin-bottom: 25px;
          font-size: 16px;
        }

        .success-message {
          color: #2e7d32;
          background-color: #edf7ed;
          padding: 10px 15px;
          border-radius: 8px;
          margin-bottom: 20px;
          font-size: 14px;
          border-left: 4px solid #2e7d32;
        }

        .error-message {
          color: #d32f2f;
          background-color: #fde8e8;
          padding: 10px 15px;
          border-radius: 8px;
          margin-bottom: 20px;
          font-size: 14px;
          border-left: 4px solid #d32f2f;
        }

        .login-form {
          display: flex;
          flex-direction: column;
          gap: 20px;
        }

        .input-group {
          position: relative;
          width: 100%;
        }

        .input-icon {
          position: absolute;
          left: 15px;
          top: 50%;
          transform: translateY(-50%);
          color: #c1212a;
          font-size: 16px;
        }

        .form-content form input {
          padding: 12px 15px 12px 40px;
          margin-bottom: 0;
          width: 100%;
          border-radius: 8px;
          border: 1px solid #ddd;
          font-size: 14px;
          transition: all 0.3s;
        }

        .form-content form input:focus {
          border-color: #c1212a;
          outline: none;
          box-shadow: 0 0 0 2px rgba(193, 33, 42, 0.2);
        }

        .login-btn {
          padding: 12px;
          width: 100%;
          background: #c1212a;
          color: white;
          border: none;
          border-radius: 8px;
          cursor: pointer;
          font-size: 16px;
          font-weight: 600;
          transition: all 0.3s;
          margin-top: 10px;
        }

        .login-btn:hover:not(:disabled) {
          background: #a51b23;
          transform: translateY(-2px);
          box-shadow: 0 5px 15px rgba(193, 33, 42, 0.3);
        }

        .login-btn:disabled {
          background: #cccccc;
          cursor: not-allowed;
        }

        .links {
          margin-top: 25px;
          display: flex;
          flex-direction: column;
          gap: 15px;
        }

        .link {
          color: #555;
          text-decoration: none;
          font-size: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: color 极速加速器
        }

        .link:hover {
          color: #c1212a;
        }

        .link strong {
          color: #c1212a;
          margin-left: 5极速加速器
        }

        .link-icon {
          margin-right: 8px;
          font-size: 14px;
        }

        .signup-link {
          font-weight: 600;
        }

        .arrow-icon {
          margin-left: 5px;
          transition: transform 0.3s;
        }

        .signup-link:hover .arrow-icon {
          transform: translateX(3px);
        }

        /* Modal Styles */
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          background: rgba(0, 0, 0, 0.7);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
          backdrop-filter: blur(5px);
        }

        .modal-form {
          background: white;
          padding: 30px;
          border-radius: 15px;
          width: 90%;
          max-width: 500px;
          box-shadow: 0 15px 40px rgba(0, 0, 0, 0.2);
          max-height: 90vh;
          overflow-y: auto;
        }

        .modal-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 25px;
        }

        .modal-header h极速加速器
          color: #c1212a;
          font-size: 24px;
        }

        .close-btn {
          background: none;
          border: none;
          font-size: 20px;
          color: #777;
          cursor: pointer;
          transition: color 0.3s;
          padding: 5px;
        }

        .close-btn:hover:not(:disabled) {
          color: #c1212a;
        }

        .close-btn:disabled {
          color: #cccccc;
          cursor: not-allowed;
        }

        .registration-form {
          display: flex;
          flex-direction: column;
        }

        .form-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 20px;
          margin-bottom: 25px;
        }

        .registration-form .input-group {
          margin-bottom: 0;
        }

        .registration-form input {
          padding: 12px 15px 12px 40px;
          width: 100%;
          border-radius: 8px;
          border: 1px solid #ddd;
          font-size: 14px;
          transition: all 0.3s;
        }

极速加速器
          border-color: #c1212a;
          outline: none;
          box-shadow: 0 0 0 2px rgba(193, 33, 42, 0.2);
        }

        .reset-form {
          display: flex;
          flex-direction: column;
          gap: 20px;
        }

        .reset-form p {
          margin-bottom: 10px;
          color: #555;
          text-align: center;
        }

        .form-actions {
          display: flex;
          gap: 15px;
          justify-content: flex-end;
        }

        .submit-btn {
          padding: 12极速加速器 25px;
          background: #c1212a;
          color: white;
          border: none;
          border-radius: 8px;
          cursor: pointer;
          font-size: 16px;
          font-weight: 600;
          transition: all 0.3s;
          width: 100%;
        }

        .submit-btn:hover:not(:disabled) {
          background: #a51b23;
          transform: translateY(-2px);
          box-shadow: 0 5px 15px rgba(193, 33, 42, 0.3);
        }

        .submit-btn:disabled {
          background: #cccccc;
          cursor: not-allowed;
        }

        .resend-btn {
          padding: 10px 15px;
          background: transparent;
          color: #c1212a;
          border: 1px solid #c1212a;
          border-radius: 8px;
          cursor: pointer;
          font-size: 14px;
          transition: all 0.3s;
        }

        .resend-btn:hover:not(:disabled) {
          background: #fde8e8;
        }

        .resend-btn:disabled {
          color: #cccccc;
          border-color: #cccccc;
          cursor: not-allowed;
        }

        .cancel-btn {
          padding: 12px 25px;
          background: #f0极速加速器f0;
          color: #555;
          border: none;
          border-radius: 8px;
          cursor: pointer;
          font-size: 16px;
          font-weight: 600;
          transition: all 0.3s;
        }

        .cancel-btn:hover:not(:disabled) {
          background: #e0e0e0;
          transform: translateY(-2px);
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
        }

        .cancel-btn:disabled {
          background: #f0f0f0;
          color: #cccccc;
          cursor: not-allowed;
        }

        @media (max-width: 768px) {
          .agent-connect-main {
            flex-direction: column;
          }
          
          .left-image {
            display: none;
          }
          
          .right-login-box {
            padding: 20px;
          }
          
          .form-content {
            padding: 30px;
          }
          
          .modal-form {
            width: 95%;
            padding: 20px;
          }
          
          .form-grid {
            grid-template-columns: 1fr;
          }
          
          .form-actions {
            flex-direction: column;
            gap: 10px;
          }
          
          .submit-btn, .cancel-btn {
            width: 100%;
          }
        }
      `}</style>
    </>
  );
};

export default AgentConnect;